<template>
    <span style="min-height: 768px">
  <!--================Contact Area =================-->
        <section class="contact_area section_gap">
            <div class="container">
                <div class="row justify-content-center" style="margin-top: 30px" data-aos="zoom-in">
                    <div class="col-lg-8 text-center">
                        <div class="main_title">
                            <h2>¿Tienes alguna pregunta?<br> comunicate con nosotros!</h2>
                            <p>¿Necesitas más información? Envía tus datos y un representante te contactará lo antes posible.</p>
                        </div>
                    </div>
			    </div>
                <div class="row" data-aos="zoom-in">

                    <div class="col-lg-9 offset-lg-2" v-if="!postMessage">
                        <form class="row contact_form"  @submit.prevent="onSubmit">
                            <div class="col-md-10">
                                <div class="form-group">
                                    <input type="text" class="form-control" v-validate="'required'" v-model="name" name="name" placeholder="Nombres" style="height: 60px" >
                                    <span class="text-danger">{{ errors.first('name') }}</span>
                                </div>
                                <div class="form-group">
                                    <input type="text" class="form-control" v-validate="'required'" v-model="last_name" name="last_name" placeholder="Apellidos" style="height: 60px" >
                                    <span class="text-danger">{{ errors.first('last_name') }}</span>
                                </div>
                                <div class="form-group">
                                    <input type="email"  v-validate="'required|email'" class="form-control" v-model="email" name="email" placeholder="Email" style="height: 60px" >
                                 <span class="text-danger">{{ errors.first('email') }}</span>
                                </div>
                                <div class="form-group">
                                    <textarea  class="form-control" v-model="subject" rows="10" id="subject" name="subject" placeholder="¿En qué podemos ayudarte?" ></textarea>
                                </div>
                            </div>

                            <div class="col-md-12">
                                 <span class="text-left pb-2" v-if="!stateButton">
                                      <g-recaptcha
                                              :data-sitekey="sitekey"
                                              :data-validate="validate"
                                              :data-callback="callback"
                                              data-btn-class="btn btn-primary mb-3 mt-3"
                                              data-language="es-419"
                                              data-size
                                      >Enviar Mensaje
                                        </g-recaptcha>
                                 </span>

                                <div  class="btn disabled" style="width: 160px;height: 50px; padding-left: 10%; background-color: grey; margin-top: 20px" disabled v-else>
                                    <half-circle-spinner
                                            :animation-duration="600"
                                            :size="25"
                                            color="#ffffff"
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-9 offset-lg-2 card" v-else>
                        <div class="row justify-content-center" style="margin-top: 90px; margin-bottom: 30px" data-aos="zoom-in">
                            <div class="col-lg-9 text-center row">
                                <div class="col-md-3">
                                   <!-- <img class="img-fluid" src="../../../public/image/landig_page/send_messaje.svg" alt="">-->
                                </div>
                                <div class="main_title col-md-8 pt-lg-2">
                                    <h2>Su mensaje se ha enviado con éxito!</h2>
                                    <p>Gracias por contactarnos, pronto uno de nuestro representantes se comunicara con usted.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--================Contact Area =================-->
    </span>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    import toastr from 'toastr'
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';
    import gRecaptcha from '@finpo/vue2-recaptcha-invisible';
    import {HalfCircleSpinner} from 'epic-spinners'
    import ar from 'vee-validate/dist/locale/ar';

    export default {
        name: 'Contact',
        components: {
            VuePhoneNumberInput,
            HalfCircleSpinner,
            gRecaptcha,
            ar
        },
        created(){

        },
        data(){
            return {
                defaultCountry: 'EC',
                countriesList: ['EC', 'VE', 'BR', 'AR', 'CL', 'COL', 'ES', 'PT'],
                translations: {
                    countrySelectorLabel: 'Código',
                    countrySelectorError: 'Choisir un pays',
                    phoneNumberLabel: 'Numero de teléfono',
                    example: 'Exemple :'
                },
                name:'',
                last_name:'',
                subject:'',
                email:'',
                results:'',
                proyect_id: process.env.VUE_APP_PROYECT_ID,
                stateButton:false,
                postMessage:false,
                sitekey:process.env.VUE_APP_RECAPTCHA,
            }
        },
        computed: {
            ...mapState,


        },
        methods:{
            validate() {
                return true;
            },
            callback(token) {
                if (token) 
                    this.onSubmit();
            },
            onSubmit() {
                this.$validator.validateAll().then((result) => {
                    this.$validator.localize('ar');
                    if (result) {
                        this.stateButton=true;
                        var url_tk = '/oauth/token';
                        axios.post(url_tk, {
                            grant_type: 'client_credentials',
                            client_secret: process.env.VUE_APP_CLIENT_AP,
                           client_id: process.env.VUE_APP_CLIENT_ID
                        }).then(response => {
                            var url = '/api/v1/cambiando/addBook';
                            var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;

                            axios.post(url, {
                                headers:{
                                    token
                                },
                                name: this.name,
                                lastName: this.last_name,
                                email: this.email,
                                message: this.subject,
                                proyect_id: this.proyect_id,
                                email_info : process.env.VUE_APP_EMAIL_INFO,
                            }).then(response => {
                                if (response.data === 'noProcess'){
                                    toastr.error('No hemos podido verificar tu direccion de email, por favor intente de nuevo o use otra dirección!');
                                    this.stateButton = false;
                                }else {
                                    this.postMessage = true;
                                    this.stateButton = false;
                                }


                            });
                        });

                    }

                });
            },
            onUpdate(payload) {
                this.results = payload.formatInternational

            },
            sendNewLeads: function () {


            }
        }

    }
</script>